@defer (on idle; on timer(5s)) {
  <aside class="mask-sticky-banner z-10 flex flex-col items-center justify-center gap-x-5 gap-y-1.5 desk:flex-row">
    @if (data.text; as text) {
      <div class="text-nowrap font-title text-[18px]">{{ text }}</div>
    }
    @if (data.pictos; as pictos) {
      <div class="flex items-center gap-x-2.5">
        @for (picto of pictos; track picto.svg; let idx = $index) {
          @if (picto.svg) {
            <app-svg
              [src]="picto.svg"
              [height]="58"
              [inline]="true"
              [ngClass]="{
                'rotate-[-13deg]': idx === 0,
                'rotate-[7deg]': idx === 1,
                '-rotate-6': idx === 2,
              }" />
          }
          @if (idx < pictos.length - 1) {
            <app-svg src="assets/icons/plus.svg" [height]="24" [inline]="true" />
          }
        }
      </div>
    }
  </aside>
}
